/* Magic Hits — playerul cu exemple din pagina de produs. */
(function () {
  'use strict';
  var box = document.querySelector('[data-mhp-player]');
  if (!box) return;
  var $ = function (s) { return box.querySelector(s); };
  var rows = Array.prototype.slice.call(box.querySelectorAll('[data-src]'));
  if (!rows.length) { box.hidden = true; return; }
  var audio = new Audio(), now = -1;
  audio.preload = 'none';
  var mmss = function (s) { if (!isFinite(s)) return ''; s = Math.floor(s); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); };

  function load(i, play) {
    now = i;
    rows.forEach(function (r, n) { r.parentNode.classList.toggle('is-now', n === i); });
    $('[data-title]').textContent = rows[i].dataset.name;
    $('[data-fill]').style.width = '0';
    $('[data-cur]').textContent = '0:00';
    $('[data-dur]').textContent = '';
    audio.src = rows[i].dataset.src;
    if (play) audio.play();
  }
  function toggle() { if (audio.paused) audio.play(); else audio.pause(); }

  box.addEventListener('click', function (e) {
    var row = e.target.closest('[data-src]');
    if (row) { var i = rows.indexOf(row); if (i === now) toggle(); else load(i, true); return; }
    if (e.target.closest('[data-play]')) toggle();
  });
  var seek = $('[data-seek]');
  seek.addEventListener('pointerdown', function (e) {
    if (!audio.duration) return;
    var r = seek.getBoundingClientRect();
    audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration;
  });
  audio.addEventListener('play', function () {
    box.classList.add('is-on'); $('[data-play]').setAttribute('aria-label', 'Pauză');
    /* un singur sunet în pagină: oprim exemplele scurte de lângă formular */
    document.dispatchEvent(new CustomEvent('mh:audio', { detail: audio }));
  });
  audio.addEventListener('pause', function () { box.classList.remove('is-on'); $('[data-play]').setAttribute('aria-label', 'Ascultă'); });
  audio.addEventListener('loadedmetadata', function () { $('[data-dur]').textContent = mmss(audio.duration); });
  audio.addEventListener('timeupdate', function () {
    if (!audio.duration) return;
    $('[data-fill]').style.width = (audio.currentTime / audio.duration * 100) + '%';
    $('[data-cur]').textContent = mmss(audio.currentTime);
  });
  audio.addEventListener('ended', function () { load((now + 1) % rows.length, now + 1 < rows.length); });
  document.addEventListener('mh:audio', function (e) { if (e.detail !== audio) audio.pause(); });
  load(0, false);
})();
